const ip = async () => {
  let ipAddress = await fetch('https://json.geoiplookup.io')
    .then(response => response.json())
    .then(data => data)

  return ipAddress
}

export default ip
